<template>
  <div class="yhc-component YhcUpLoad" :class="parentClass">
    <input
      @change="customUploadHandle"
      ref="customUpload"
      :accept="accept"
      multiple
      type="file"
      style="opacity: 0; position: absolute; right: 9999px"
    />

    <PrivateLabel v-if="label" :labelClass="labelClass" :label="label"></PrivateLabel>

    <div class="content">
      <div class="item-box">
        <div class="item" :key="index" v-for="(item, index) in dev_mediaList">
          <div class="img-box">
            <img @click="tapImage(item, index)" :src="item.frameUrl || item.mediaUrl" />

            <i class="el-icon-close del" @click="handleCommand(`del-${index}`)"></i>

            <el-dropdown @command="handleCommand" class="more">
              <i class="el-icon-more"></i>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item v-if="!hiddenSticky && !isSingleMedia" :command="`stickyTop-${index}`">
                  置顶
                </el-dropdown-item>
                <el-dropdown-item v-if="!hiddenDelete" :command="`del-${index}`">删除</el-dropdown-item>
                <el-dropdown-item v-if="!hiddenCop" :command="`cop-${index}`">裁剪</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>

          <div class="footer-text" :style="getProportion(item)">
            {{ item.width || 0 }} * {{ item.height || 0 }} {{ item.size }}
          </div>
        </div>
        <i v-if="!onlyRead" @click="upload" class="item el-icon-plus uploader-icon"></i>
      </div>
    </div>

    <PrivateEndLabel
      v-if="endLabel"
      :isBtnEndLabel="isBtnEndLabel"
      :endLabelType="endLabelType"
      :endLabelStyle="endLabelStyle"
      :endLabel="endLabel"
      @tapEndLabel="$_tapEndLabel"
    ></PrivateEndLabel>

    <el-dialog
      title="图片剪裁"
      :visible.sync="cropperConfig.dialogVisible"
      class="crop-dialog"
      append-to-body
      top="6vh"
    >
      <div class="gb-fjae09y0249t-cropper-content" v-if="cropperConfig.dialogVisible">
        <div class="cropper" style="text-align: center">
          <vueCropper
            ref="cropper"
            :img="cropperConfig.img"
            :outputSize="cropperConfig.size"
            :outputType="cropperConfig.outputType"
            :info="false"
            :full="cropperConfig.full"
            :canMove="cropperConfig.canMove"
            :canMoveBox="cropperConfig.canMoveBox"
            :original="cropperConfig.original"
            :autoCrop="cropperConfig.autoCrop"
            :fixed="cropperConfig.fixed"
            :fixedNumber="cropperConfig.fixedNumber"
            :centerBox="cropperConfig.centerBox"
            :infoTrue="cropperConfig.infoTrue"
            :fixedBox="cropperConfig.fixedBox"
            :autoCropWidth="cropperConfig.autoCropWidth"
            :autoCropHeight="cropperConfig.autoCropHeight"
          />
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cropperConfig.dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="finish">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import propsMixin from './componentsData/propsMixin';
import getFileType from '@/utils/getUploadFileType';

import PrivateLabel from './componentsData/PrivateLabel.vue';
import PrivateEndLabel from './componentsData/PrivateEndLabel.vue';

import fileOrBlobToDataURL from 'evenlea-utils/file/fileOrBlobToDataURL';
import dataURLtoFile from 'evenlea-utils/file/dataURLtoFile';

let identifierName = 'YhcUpLoad';

function getAspectRatioString(width, height) {
  if (height === 0) throw new Error('高度不能为0');

  // 计算最大公约数（GCD）
  const gcd = (a, b) => (b === 0 ? a : gcd(b, a % b));
  const divisor = gcd(Math.abs(width), Math.abs(height));

  // 约分并保持分母为正
  const simplifiedWidth = width / divisor;
  const simplifiedHeight = height / divisor;
  const finalHeight = Math.abs(simplifiedHeight);
  const finalWidth = simplifiedHeight < 0 ? -simplifiedWidth : simplifiedWidth;

  return `${Math.abs(finalWidth)}:${Math.abs(finalHeight)}`;
}

// 示例用法
// console.log(`getAspectRatioString`);
// console.log(getAspectRatioString(498, 747)); // 输出 "16:9"
// console.log(getAspectRatioString(16, 9)); // 输出 "16:9"
// console.log(getAspectRatioString(-8, 4)); // 输出 "2:1"
// console.log(getAspectRatioString(10, 5)); // 输出 "2:1"

export default {
  name: identifierName,
  components: { PrivateLabel, PrivateEndLabel },
  mixins: [propsMixin],
  watch: {},
  data() {
    return {
      dev_mediaList: [],

      // 裁剪组件的基础配置cropperConfig
      cropperConfig: {
        currIndex: -1,
        dialogVisible: false,
        // 裁剪图片的地址
        img: '',
        // 裁剪框的大小信息
        info: true,
        // 裁剪生成图片的质量
        outputSize: 1,
        // 裁剪生成图片的格式
        outputType: 'png',
        // 图片是否允许滚轮缩放
        canScale: true,
        // 是否默认生成截图框
        autoCrop: true,
        // 截图框能否拖动
        canMoveBox: true,
        // 默认生成截图框宽度
        autoCropWidth: 200,
        // 默认生成截图框高度
        autoCropHeight: 200,
        // 固定截图框大小 不允许改变
        fixedBox: false,
        // 是否开启截图框宽高固定比例
        fixed: true,
        // 截图框的宽高比例
        fixedNumber: [1, 1],
        // 是否输出原图比例的截图
        full: false,
        // 上传图片按照原始比例渲染
        original: false,
        // 截图框是否被限制在图片里面
        centerBox: true,
        // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
        infoTrue: true,
      },
    };
  },
  props: {
    // 隐藏置顶按钮
    hiddenSticky: {
      type: Boolean,
      default: false,
    },
    // 隐藏删除按钮
    hiddenDelete: {
      type: Boolean,
      default: false,
    },
    // 隐藏裁剪按钮
    hiddenCop: {
      type: Boolean,
      default: false,
    },
    // 是否只能有一张图片
    isSingleMedia: {
      type: Boolean,
      default: false,
    },
    // 1:1 | 2:3
    proportion: {
      type: String,
      default: '',
    },
    // {
    // type: "Image / Video",
    // mediaUrl: "",
    // frameUrl: ""
    // }
    value: {
      type: [Array, Object, String],
      default: () => [],
    },
    // "application/pdf"
    // "video/*"
    // "image/*"
    accept: {
      type: String,
      default: 'video/*, image/*',
    },
  },
  watch: {
    value: {
      handler(mediaObj, oldVal) {
        if (Object.prototype.toString.call(mediaObj) === '[object Array]') {
          this.dev_mediaList = mediaObj;
        } else {
          this.dev_mediaList = [mediaObj];
        }

        if (this.isSingleMedia) {
          if (this.dev_mediaList[0] && this.dev_mediaList[0].mediaUrl != '') {
            this.dev_mediaList = [this.dev_mediaList[0]];
          } else {
            this.dev_mediaList = [];
          }
        }
      },
      immediate: true,
    },
  },
  created() {},
  mounted() {},
  methods: {
    getProportion(item) {
      // if (!item.width || !item.width) {
      //   return {
      //     color: '',
      //   };
      // }

      let res = getAspectRatioString(item.width, item.height);
      console.log(res);
      if (!this.proportion) {
        return {
          color: '',
        };
      } else {
        if (res === this.proportion) {
          return {
            color: '',
          };
        }

        if (res !== this.proportion) {
          return {
            color: '#f00',
          };
        }
      }
    },
    handleCommand(cmdText) {
      let arr = cmdText.split('-');
      let type = arr[0];
      let index = arr[1];
      this[type](index);
    },
    stickyTop(index) {
      if (this.isSingleMedia) {
      } else {
        let item = this.dev_mediaList.splice(index, 1);
        this.dev_mediaList.unshift(...item);
      }
      console.log(this.dev_mediaList);
      this.$emit('input', this.dev_mediaList);
    },
    del(index) {
      this.dev_mediaList.splice(index, 1);
      if (this.isSingleMedia) {
        this.$emit('input', undefined);
      } else {
        this.$emit('input', this.dev_mediaList);
      }
    },
    cop(index) {
      let item = this.dev_mediaList[index];
      console.log(`cop`);
      console.log(item.mediaUrl);

      this.cropperConfig.img = item.mediaUrl;
      this.cropperConfig.currIndex = index;

      if (!this.proportion) {
        this.cropperConfig.fixed = false;
      }

      if (this.proportion === '1:1') {
        this.cropperConfig.fixed = true;
        this.cropperConfig.fixedNumber = [1, 1];
        // this.$set(this.cropperConfig.fixedNumber, 0, 1);
        // this.$set(this.cropperConfig.fixedNumber, 1, 1);
      }

      if (this.proportion === '2:3') {
        this.cropperConfig.fixed = true;
        this.cropperConfig.fixedNumber = [2, 3];
        // this.$set(this.cropperConfig.fixedNumber, 0, 2);
        // this.$set(this.cropperConfig.fixedNumber, 1, 3);
      }

      this.$nextTick(() => {
        this.cropperConfig.dialogVisible = true;
      });
    },

    finish() {
      // 获取截图的 blob 数据
      this.$refs.cropper.getCropBlob(async (blob) => {
        this.cropperConfig.dialogVisible = false;

        let base64 = await fileOrBlobToDataURL(blob);
        let file = dataURLtoFile(base64, `${+new Date()}.png`);

        await this.yhcAjax.uploadFile(file).then((mediaObj) => {
          console.log(`getCropBlob`);
          console.log(mediaObj);

          if (this.isSingleMedia) {
            this.dev_mediaList = mediaObj;
          } else {
            this.dev_mediaList.splice(this.cropperConfig.currIndex, 1, mediaObj);
          }
          this.$emit('input', this.dev_mediaList);
        });
      });
      // 获取截图的 base64 数据
      // this.$refs.cropper.getCropData(data => {
      //     console.log(data)
      // })
    },

    tapImage(item, index) {
      this.$emit('tapImage', item, index);
    },
    upload(v) {
      this.$refs.customUpload.click();
    },
    async customUploadHandle(e) {
      let fileList = e.target.files;
      if (!fileList.length) {
        return;
      }
      for (let index = 0; index < fileList.length; index++) {
        const f = fileList[index];

        let type = getFileType(f.name);
        if (!type) {
          this.yhcToastShow({
            message: '文件类型有误',
            type: 'warning',
          });
          return;
        }
        this.yhcLoadingShow();

        if (type == 'Video') {
          await this.yhcAjax.uploadFile(f).then((mediaObj) => {
            console.log(mediaObj);
            if (this.isSingleMedia) {
              this.dev_mediaList = mediaObj;
            } else {
              this.dev_mediaList.push(mediaObj);
            }
            this.$emit('input', this.dev_mediaList);
            this.yhcLoadingHide();
          });
        }

        if (type == 'Image') {
          await this.yhcAjax.uploadFile(f).then((mediaObj) => {
            console.log(mediaObj);

            if (this.proportion) {
              let res = getAspectRatioString(mediaObj.width, mediaObj.height);

              if (res !== this.proportion) {
                window.yhcNotifyShow({
                  title: '系统消息',
                  message: '图片尺寸不正确，请重新上传！',
                  type: 'error',
                });
              }
            }

            if (this.isSingleMedia) {
              this.dev_mediaList = mediaObj;
            } else {
              this.dev_mediaList.push(mediaObj);
            }
            this.$emit('input', this.dev_mediaList);
            this.yhcLoadingHide();
          });
        }

        // if (type == 'Adobe') {
        //   await this.yhcAjax.uploadFile(f).then((mediaObj) => {
        //     console.log(mediaObj);
        //     // mediaObj.mediaUrl = '/static/imgs/app-pdf.jpg'
        //     if (this.isSingleMedia) {
        //       this.dev_mediaList = mediaObj;
        //     } else {
        //       this.dev_mediaList.push(mediaObj);
        //     }
        //     this.$emit('input', this.dev_mediaList);
        //     this.yhcLoadingHide();
        //   });
        // }
      }
    },
  },
};
</script>

<style lang="scss" scoped type="text/css">
@import './componentsData/labelComponentCommonStyle';
.YhcUpLoad {
  @include labelCommon();
  // padding-left: 90px;
  .item-box {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;
    .item {
      margin-right: 24px;
      margin-bottom: 24px;
      width: 130px;
      height: 130px;
      border: 1px solid #a1a1a1;
      position: relative;
      .img-box {
        width: 130px;
        height: 130px;
        overflow: hidden;
        position: relative;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .del {
        position: absolute;
        top: -10px;
        right: -20px;
        cursor: pointer;
        background-color: rgba(37, 37, 37, 0.6);
        color: #fff;
        border-radius: 50%;
        padding-top: 12px;
        padding-right: 20px;
        padding-bottom: 4px;
        padding-left: 4px;
        font-size: 12px;
        &:hover {
          color: #f56c6c;
        }
      }
      .more {
        position: absolute;
        bottom: -12px;
        right: -20px;
        cursor: pointer;
        background-color: rgba(37, 37, 37, 0.6);
        color: #fff;
        border-radius: 50%;
        padding-top: 4px;
        padding-right: 20px;
        padding-bottom: 12px;
        padding-left: 4px;
        font-size: 12px;
        &:hover {
          color: var(--yhc-color-primary);
        }
      }
      .footer-text {
        position: absolute;
        color: var(--yhc-color-primary);
        font-size: 12px;
        top: 100%;
        left: 0;
        margin-top: 4px;
        overflow: hidden;
        height: 16px;
        width: 100%;
      }
    }
  }
  .uploader-icon {
    width: 100px;
    height: 80px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 32px;
    color: #5f5f5f;
    border: 1px dashed #d9d9d9;
    cursor: pointer;
    &:hover {
      border-color: var(--yhc-color-primary);
      color: var(--yhc-color-primary);
    }
  }
}
</style>

<style lang="scss">
.gb-fjae09y0249t-cropper-content {
  .cropper {
    width: auto;
    height: 350px;
  }
}
</style>
